import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const apiClient = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const PAYPAL_LINKS = {
  basic: "https://www.paypal.com/paypalme/Felopic/149",
  professional: "https://www.paypal.com/paypalme/Felopic/499",
  executive: "https://www.paypal.com/paypalme/Felopic/1499",
  generic: "https://www.paypal.com/paypalme/Felopic",
};

export const SOCIAL = {
  instagram: "https://www.instagram.com/camointelligence/",
  discord: "https://discord.com/users/felopic",
  discordHandle: "@felopic",
};
